import React from 'react';
import {DataFetcherProvider} from './context';
import {deserializeJS} from './serialize-deserialize';

export const wrapAppWithDataFetcherProvider = (
  App: React.ReactElement,
  disableDevTools?: boolean,
) => {
  const initialState = getInitialState();
  const hasInitialState = initialState !== null;
  const initialData = initialState ?? new Map();

  return {
    content: (
      <DataFetcherProvider
        initialData={initialData}
        disableDevTools={disableDevTools}
      >
        {App}
      </DataFetcherProvider>
    ),
    hasInitialState,
  };
};

/**
 * Collects the initial state from all elements with the data-tadarida-initial-state attribute.
 */
const getInitialState = () => {
  const initialStateElements = document.querySelectorAll(
    '[data-tadarida-initial-state]',
  );

  if (!initialStateElements.length) {
    return null;
  }

  const initialStateMap = new Map();

  initialStateElements.forEach(element => {
    try {
      const elementData = deserializeJS(element.innerHTML);

      const elementMap = new Map(elementData);

      elementMap.forEach((value, key) => initialStateMap.set(key, value));
    } catch (e) {
      console.warn(e);
    }
  });

  return initialStateMap;
};
